import {
  makeStyles,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@material-ui/core";
import CsvFileUploadInput from "components/CsvFileUploadInput";
import TableResultCsvFileUpload from "components/TableResultCsvFileUpload";
import { useState, Fragment, useEffect } from "react";
import { Button, useDataProvider } from "react-admin";
import IconPlus from "@material-ui/icons/Add";
import { delay } from "utils/tools";
import TemplateUploadCreditNoteButton from "./TemplateUploadCreditNoteButton";

export interface ICreditNoteFromCsv {
  description: string;
  amount: string;
  dueDate: string;
  parentId: string;
  projectCode: string;
  schoolId: string;
  tbfCode: string;
  type: string;
  invoiceReferenceNumber: string;
  status: string;
}

const CreateAdhocCreditNoteByCsvButton = () => {
  const [open, setOpen] = useState<boolean>(false);
  const [creditNotes, setCreditNotes] = useState<ICreditNoteFromCsv[]>([]);
  const [results, setResults] = useState<ICreditNoteFromCsv[]>([]);
  const dataProvider = useDataProvider();

  const useStyles = makeStyles({
    dialog: {
      "& .MuiDialog-paper": {
        overflowY: "unset",
      },
    },
    table: {
      marginTop: "10px",
      padding: "1rem",
    },
  });

  const classes = useStyles();

  const handleOpenDialog = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setCreditNotes([]);
    setResults([]);
  };

  const handleCreateCreditNote = (
    creditNote: ICreditNoteFromCsv,
    index: number
  ) => {
    dataProvider
      .create("commercialDocuments", {
        data: {
          parentId: Number(creditNote.parentId),
          type: creditNote.type,
          invoiceReferenceNumber:
            creditNote.invoiceReferenceNumber === "-"
              ? null
              : creditNote.invoiceReferenceNumber,
          status: "draft",
          commercialDocumentItem: {
            amount: Math.round(Number(creditNote.amount) * 100.0),
            schoolId: Number(creditNote.schoolId),
            description: creditNote.description,
            tbfCode: creditNote.tbfCode,
            projectCode: creditNote.projectCode,
          },
        },
      })
      .then(() => {
        let tempCreditNotes = creditNotes;
        tempCreditNotes[index].status = "Success";
        setResults([...tempCreditNotes]);
      })
      .catch((err) => {
        let tempCreditNotes = creditNotes;
        tempCreditNotes[index].status = `Error, ${err.message}`;
        setResults([...tempCreditNotes]);
      });
  };

  const fetchCreditNote = async (creditNotes: ICreditNoteFromCsv[]) => {
    for (const creditNote of creditNotes) {
      const index = creditNotes.indexOf(creditNote);
      if (creditNote.status === "Loading...") {
        await handleCreateCreditNote(creditNote, index);
        await delay(3500);
      }
    }
  };

  useEffect(() => {
    if (creditNotes.length > 0) {
      fetchCreditNote(creditNotes);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [creditNotes]);

  return (
    <Fragment>
      <Button
        label="Import Mass Adhoc Credit Note"
        onClick={handleOpenDialog}
        style={{ float: "right" }}
      >
        <IconPlus />
      </Button>
      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.dialog}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">
          Import Adhoc Credit Note by CSV
        </DialogTitle>
        <DialogContent>
          <CsvFileUploadInput
            commercialDocumentType="credit_note"
            setValues={(values) => {
              setCreditNotes(values);
              setResults(values);
            }}
            isHaveNullableField
          />

          {creditNotes.length > 0 && (
            <TableResultCsvFileUpload records={results} />
          )}
        </DialogContent>
        <DialogActions>
          <TemplateUploadCreditNoteButton />
          <Button onClick={handleClose} color="secondary" label="Back" />
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

export default CreateAdhocCreditNoteByCsvButton;
